import { type VoidFunctionComponent } from 'react';

import { Status } from '../../../../../../../shared/builds/types';
import Button from '../../../../../generic/Button/Button';
import { icons } from '../../../../../generic/Icon/icons';
import { Menu } from '../../../../../generic/Menu/index';
import type { Dependency, DependencyState } from '../../../../../../../shared/dependenciesV2';

import { AnalyzedMenu, BuildDropdown, ErrorDropdown } from './ActionMenus';

import styles from '../DependencyRow.module.less';

type Props = {
  dependency: Dependency;
  status: Status;
  removeDependency: (locator: string, isManual: boolean) => void;
  setDependencyLocatorToEdit?: (dependency: string | null) => void;
  setInProgressBuildId: (buildId: number | null) => void;
  isProjectScope: boolean;
  handleOverwriteManualDependency: (overwriteDependencyLocator: string) => void;
};

export type MenuProps = Omit<Props, 'status' | 'setInProgressBuildId' | 'dependency' > & {
  locator: string;
  isManual: boolean;
};

export type ErrorMenuProps = MenuProps & {
  dependencyState: DependencyState;
};

export type BuildMenuProps = MenuProps & {
  setInProgressBuildId: (buildId: number | null) => void;
};

const DependencyActionDropdown: VoidFunctionComponent<Props> = ({
  dependency,
  status,
  removeDependency,
  setDependencyLocatorToEdit,
  setInProgressBuildId,
  isProjectScope,
  handleOverwriteManualDependency,
}) => {
  return (
    <div className={styles.DependencyRowDropdown}>
      <Menu
        gap={4}
        direction="left"
        position="initial"
        menuButton={<Button type="outline" icon={icons.ellipsisHorizontal} onClick={(e) => e.stopPropagation()} />}
      >
        {status === Status.Analyzed && (
          <AnalyzedMenu
            locator={dependency.locator}
            isManual={dependency.isManual}
            removeDependency={removeDependency}
            setDependencyLocatorToEdit={setDependencyLocatorToEdit}
            isProjectScope={isProjectScope}
            handleOverwriteManualDependency={handleOverwriteManualDependency}
          />
        )}
        {(status === Status.Failed || status === Status.Unknown) && (
          <ErrorDropdown
            locator={dependency.locator}
            isManual={dependency.isManual}
            removeDependency={removeDependency}
            dependencyState={dependency.status}
            isProjectScope={isProjectScope}
            handleOverwriteManualDependency={handleOverwriteManualDependency}
          />
        )}
        {status === Status.InProgress && (
          <BuildDropdown
            locator={dependency.locator}
            isManual={dependency.isManual}
            removeDependency={removeDependency}
            setInProgressBuildId={setInProgressBuildId}
            isProjectScope={isProjectScope}
            handleOverwriteManualDependency={handleOverwriteManualDependency}
          />
        )}
      </Menu>
    </div>
  );
};

export default DependencyActionDropdown;
